import { render, staticRenderFns } from "./AgentServiceMessageList.vue?vue&type=template&id=9336ab4c&scoped=true"
import script from "./AgentServiceMessageList.vue?vue&type=script&lang=js"
export * from "./AgentServiceMessageList.vue?vue&type=script&lang=js"
import style0 from "./AgentServiceMessageList.vue?vue&type=style&index=0&id=9336ab4c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../Desktop/sx_workspace/xsou-com/xsou-da-vue/h5/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9336ab4c",
  null
  
)

export default component.exports